import { API_ORIGIN } from "@/lib/apiOrigin";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, FileText } from "lucide-react";
import { toast } from "sonner";
import { downloadPdf } from "@/lib/downloadPdf";
import { api, tokenStore } from "@/lib/api";
import { formatCHF, formatDateTime } from "@/lib/format";

const BASE = API_ORIGIN;

export default function Invoices() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/invoices/mine").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  }, []);

  const download = async (id, number) => {
    try {
      await downloadPdf(`${BASE}/api/invoices/${id}/pdf`, `DapNow-${number}.pdf`, { Authorization: `Bearer ${tokenStore.get()}` });
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <div className="space-y-5" data-testid="customer-invoices-page">
      <div>
        <p className="overline">Documenti</p>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tighter mt-1">Fatture</h1>
      </div>

      {loading ? (
        <div className="card-soft p-10 text-center text-dapnow-muted">Caricamento…</div>
      ) : items.length === 0 ? (
        <div className="card-soft p-10 text-center">
          <FileText className="h-6 w-6 mx-auto text-dapnow-muted" />
          <p className="mt-3 text-sm text-dapnow-muted">Le fatture verranno generate dopo il pagamento dei tuoi ordini.</p>
        </div>
      ) : (
        <div className="card-soft overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-dapnow-bg text-left">
                <tr>
                  <Th>Numero</Th>
                  <Th>Data</Th>
                  <Th>Ordine</Th>
                  <Th>Totale</Th>
                  <Th></Th>
                </tr>
              </thead>
              <tbody>
                {items.map((inv) => (
                  <tr key={inv.id} className="border-t border-dapnow-line" data-testid={`invoice-row-${inv.id}`}>
                    <Td className="font-mono text-xs">{inv.number}</Td>
                    <Td className="text-xs text-dapnow-muted">{formatDateTime(inv.issued_at)}</Td>
                    <Td className="font-mono text-xs">#{inv.order_id.slice(0, 8).toUpperCase()}</Td>
                    <Td className="font-display font-semibold">{formatCHF(inv.total)}</Td>
                    <Td>
                      <button
                        onClick={() => download(inv.id, inv.number)}
                        data-testid={`invoice-download-${inv.id}`}
                        className="inline-flex items-center gap-1.5 text-dapnow-blue text-sm font-semibold hover:underline"
                      >
                        <Download className="h-4 w-4" /> PDF
                      </button>
                    </Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Link to="/app/profile" className="text-sm font-semibold text-dapnow-blue">← Torna al profilo</Link>
    </div>
  );
}

function Th({ children }) { return <th className="px-4 py-3 overline text-[10px] font-semibold">{children}</th>; }
function Td({ children, className = "" }) { return <td className={`px-4 py-3 ${className}`}>{children}</td>; }
